var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

/**
 * ClearButton
 *
 * http://getbootstrap.com/css/#helper-classes-close
 */
var ClearButton = function ClearButton(_ref) {
    var className = _ref.className,
        label = _ref.label,
        _onClick = _ref.onClick,
        props = _objectWithoutProperties(_ref, ["className", "label", "onClick"]);

    return React.createElement(
        "button",
        _extends({}, props, {
            "aria-label": label,
            className: "close rbt-close clear-button",
            onClick: function onClick(e) {
                e.stopPropagation();
                e.preventDefault();
                _onClick(e);
            },

            type: "button" }),
        React.createElement(
            "span",
            { "aria-hidden": "true" },
            "\xD7"
        ),
        React.createElement(
            "span",
            { className: "sr-only visually-hidden" },
            label
        )
    );
};

export default ClearButton;